import React from 'react';
import {useState} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { createTheme, StyledEngineProvider} from '@mui/material/styles';
import { ThemeProvider } from '@mui/material/styles';
import { StateProvider } from './reducers/store';

import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import QueryPageRaw from './components/QueryPageRaw';
import QueryPageReduced from './components/QueryPageReduced';
import QueryResults from './components/QueryResults';
import LogBook from './components/LogBook';
import PrimaryNav from './components/PrimaryNav';
import MetData from './components/MetData';
import './App.css';

const theme = createTheme(({
    palette: {
        primary: {
            main: '#192031',
        },
        secondary: {
            main: '#ddd',
        },
    },
}));

const App = () => {
    const [user, setUser] = useState(false);

   
        return (
            <StateProvider>
                <Router>
                    <StyledEngineProvider injectFirst>
                        <ThemeProvider theme={theme}>
                        <PrimaryNav user={user} setUserName={setUser} /> 
                        <Header />
                        <Routes>
                            <Route path="/results/raw/:query_id?" element={ <QueryResults user={user} reduced={false} />}/>

                            <Route path="/results/reduced/:query_id?" element={ <QueryResults user={user} reduced={true}/>}/>
            
                            <Route path="/query/:query_id" element={ <QueryResults user={user} query={true} />}/>
                                
                            <Route path="/query/raw" element={ <QueryPageRaw user={user}/>}/>

                            <Route path="/query/reduced" element={ <QueryPageReduced user={user}/>}/>

                            <Route path="/metdata" element={ <MetData user={user} />}/>
                        
                            <Route path="/" element={<Home />}/>
                        </Routes>
                        <Footer />
                        </ThemeProvider>
                    </StyledEngineProvider>
                </Router>
            </StateProvider>
        );

    
}

export default App;